import type { ReactNode } from "react";
import type { LoadPhase } from "src-next/modules/clinical-insights/loadPhase";

export const ANALYSIS_CARD_IDS = [
  "tratamentos",
  "protocolos",
  "condutas",
  "problemas",
  "planos",
  "diagnosticos",
  "service",
  "alergias",
] as const;

export type AnalysisCardId = (typeof ANALYSIS_CARD_IDS)[number];

/** Análises que usam o workspace com filtro lateral (profissional no painel esquerdo). */
export const WORKSPACE_ANALYSES = new Set<AnalysisCardId>([
  "condutas",
  "problemas",
  "planos",
  "tratamentos",
  "protocolos",
  "diagnosticos",
  "service",
  "alergias",
]);

export interface ClinicalInsightDateRange {
  startDate?: string;
  endDate?: string;
}

export type ClinicalPractitionerEntry = {
  resource?: { id?: string; name?: fhir5.HumanName[] };
};

export interface ClinicalInsightChildProps {
  dateRange?: ClinicalInsightDateRange;
  practitionerId?: string;
  practitioner?: ClinicalPractitionerEntry[];
  accentColor?: string;
  onPatientStatsChange?: (filtered: number, total: number) => void;
  practitionerFilter?: ReactNode;
  onLoadPhaseChange?: (phase: LoadPhase) => void;
  onSelectAllPractitioners?: () => void;
  onPreviousPeriod?: () => void;
  periodDisplayLabel?: string;
  /** Card visível na URL — evita fetch/load phase em análises ocultas (display:none). */
  isActive?: boolean;
}
